import React, { useEffect, useState } from "react";

import moment from "moment";
import { OrderProps } from "../../types/order";

type Props = {
  orders: OrderProps[];
};

const OrderPdf = ({ orders }: Props) => {
  const companyName = process.env.REACT_APP_COMPANY_NAME_EN;

  const [rotate, setRotate] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      if (img.height > img.width) {
        setRotate(true);
      }
    };
    img.src = orders[0].image;
  }, [orders[0].image]);

  useEffect(() => {
    const platform = window.navigator.platform;
    setIsIos(/Mac|iPod|iPhone|iPad/.test(platform) ? true : false);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        display: "grid",
        height: isIos ? "648px" : "148mm",
        minHeight: isIos ? "648px" : "148mm",
        width: "105mm",
        padding: isIos ? "0px 10px" : "5px 20px 20px 20px",
        overflow: "hidden",
      }}
    >
      <h1 className="text-2xl font-bold text-black text-center">
        {companyName}
      </h1>
      <div className="flex justify-between mt-2">
        <div className="grid gap-2">
          <p className="text-base text-black font-semibold">
            <span className="font-bold mr-[13px]">પાર્ટી </span>:{" "}
            {orders[0]?.party?.firm_name}
          </p>
          <p className="text-base text-black font-semibold">
            <span className="font-bold">તારીખ </span>:{" "}
            {orders[0]?.created_at
              ? moment(orders[0]?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                  "DD-MM-YYYY HH:mm:ss"
                )
              : ""}
          </p>
        </div>
        <p className="text-base text-black font-semibold">
          <span className="font-bold">પ્રોસેસ :</span>{" "}
          {orders[0]?.process?.name || ""}
        </p>
      </div>
      <div className="w-full h-[230px] p-5 -mt-3">
        {orders[0]?.image && (
          <img
            className={`w-full h-full object-contain ${
              rotate ? "rotate-90" : ""
            }`}
            src={`${orders[0].image}?order=${orders[0].id}`}
            alt=""
          />
        )}
      </div>
      <table className="w-full border-collapse -mt-3">
        <tbody>
          <tr>
            <td className="text-center text-base text-black w-[80px] px-[6px] py-1 font-bold border border-black">
              ઓર્ડર નં.
            </td>
            <td className="text-base text-black px-[6px] py-1 font-bold border border-black">
              આઈટમ
            </td>
            <td className="text-center text-base text-black w-[80px] px-[6px] py-1 font-bold border border-black">
              નંગ
            </td>
            <td className="text-center text-base text-black w-[80px] px-[6px] py-1 font-bold border border-black">
              પરત નં.
            </td>
          </tr>

          {orders.map((order, index) => (
            <tr key={index}>
              <td className="text-center text-base text-black px-[6px] py-1 font-semibold border border-black">
                {order?.id}
              </td>
              <td className="text-base text-black px-[6px] py-1 font-semibold border border-black">
                {order?.item?.name || ""}
                {order?.inch > 1 && ` ${order.inch} Inch`}
              </td>
              <td className="text-center text-base text-black px-[6px] py-1 font-semibold border border-black">
                {order?.qty || ""}
              </td>
              <td className="text-center text-base text-black px-[6px] py-1 font-semibold border border-black">
                {order?.delivered_qty || ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ pageBreakAfter: "always", breakAfter: "page" }}></div>
    </div>
  );
};
export default OrderPdf;
